import G6 from '@antv/g6';
import registerBehavior from './behavior';
import registerNode from './shape';

/**
 * 拓扑插件-全局配置处理
 */

// 注册自定义交互
registerBehavior(G6);

// 注册自定义节点
registerNode(G6);


export default G6;
